import { environment as base } from './environment';
import { apiUrls } from './api-urls';
import type { Environment } from './environment';

export const environment: Environment = {
  ...base,
  apiProxyUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-core-api/v3.0.0/',
  ssoApiProxyUrl: 'https://uhci-ui-internal-stage.optum.com/',
  postLoginProxyUrl:  '/uhci/login/stage/',
  ohidApiProxyUrl: 'https://uhcinsights-stage.uhc.com/',
  originUrl: '/',
  redirectUri: 'https://uhci-ui-internal-stage.optum.com/',
  domain: '.uhc.com',
  domainEnvironment: ['https://uhci-ui-internal-stage.optum.com'],
  cookieEnvironment: 'STG_',
  featureFlagUrl: '/feature-flags/',
  upstreamEnv: 'stage',
  goldCardEnvironment: 'stage',
  goldCardabyssparcelUrl: 'https://uhci-ui-internal-stage.optum.com/abyss-parcel.js',
  qualtricksEnvCheck: 'stage',
  clickStreamUrl:
    'https://assets.adobedtm.com/512027f42d3c/c18a9fa8e51b/launch-EN8719bda8a40e4a799c546a079b0dbd92-staging.min.js',
  production: false,
  staging: true,
  goldCardFeatureToggle: 'true',
  apiUrls: {
    ...apiUrls,
    bulkTinRUrl: '/bulk-api/',
    SsoRedirectUri:
      'https://stage-sso.uhc.com/ext/as/authorization.oauth2?pfidpadapterid=OptumIdOIDCStage&client_id=PED42235&response_' +
      'type=code&redirect_uri=https://uhci-ui-internal-stage.optum.com/login&scope=openid+profile+email&state=PED&prompt=none',
    SsoRedirectLogin:
      'https://identity.nonprod.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code&' +
      'redirect_uri=https://uhci-ui-internal-stage.optum.com/login&scope=openid+profile+email&state=PED&prompt=login',
    SsoLogoutUrl:
      'https://api-stage.linkhealth.com/session/signout?redirect=https://provider-stage.linkhealth.com/' +
      'content/odin/en/provider-dashboard/public/signout.html?logOut=true',
    linkLoginPage: 'https://provider-stage.linkhealth.com',
    providerLoginPage: 'https://secure-nonprod.uhcprovider.com/stage/#/',
  },
};
